import Price from '~/utils/Price/Price';

export default class ProductComputedPrice {
	type: string;

	price: Price;

	description: string;

	selected: boolean;

	constructor(type: string, price: Price, description: string, selected: boolean) {
		this.type = type;
		this.price = price;
		this.description = description;
		this.selected = selected;
	}
}
